var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiBox from '@mui/material/Box';
import Typography from '../Typography';
import colors from '../../colors';
import MuiChip from '@mui/material/Chip';
export var LabelWithChip = function (_a) {
    var label = _a.label, chipLabel = _a.chipLabel, isActive = _a.isActive;
    return (_jsxs(MuiBox, __assign({ sx: { display: 'flex', flexWrap: 'nowrap', alignItems: 'center' } }, { children: [_jsx(Typography, __assign({ color: isActive ? colors.blue[500] : colors.grey[800], variant: 'body' }, { children: label })), _jsx(MuiBox, __assign({ sx: {
                    minWidth: '20px',
                    marginLeft: '4px',
                } }, { children: _jsx(MuiChip, { label: chipLabel }) }))] })));
};
